import * as shrink from '../actions/shrink.action'


// 初始化数据值
const initialState =  false

export function reducer( state = initialState,action: shrink.shrinkActions) {
  switch (action.type) {
    case shrink.SET_MENU_SHRINK:
        return action.payload;
    default:
      return state;
  }
}